module.exports = __webpack_public_path__ + "static/media/dash.17f637b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/pierna_negra_papa/curativa/dash.png
// module id = 2009
// module chunks = 3